import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IDisposeSample } from 'src/app/shared/models/i-dispose-sample.modal';
import {
  IDisposeSamplePrintHistory,
  IDisposeSamplePrintRequest,
} from 'src/app/shared/models/i-dispose-sample-print-history.modal';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient) {}

  public getAllTabs() {
    return this.http.get<any>(`${environment.baseUrl}admin/getalltabs`);
  }

  public getTabConfigItems(tabName: string) {
    return this.http.get<any>(`${environment.baseUrl}admin/gettabconfig/${tabName}`);
  }

  public updateSettings(payload: any, tabId: string): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}admin/updatetabconfig/${tabId}`, payload);
  }

  public getAllRoles() {
    return this.http.get<any[]>(`${environment.baseUrl}admin/getallroles`);
  }

  public getDisposeSamples(fromDate: string, toDate: string): Observable<IDisposeSample[]> {
    return this.http.get<IDisposeSample[]>(`${environment.baseUrl}project/getdisposesamples`, {
      params: { fromDate, toDate },
    });
  }

  public addDisposeSamplePrintHistory(payload: IDisposeSamplePrintRequest): Observable<IDisposeSamplePrintHistory> {
    return this.http.post<IDisposeSamplePrintHistory>(`${environment.baseUrl}project/adddisposesampleprinthistory`, payload);
  }

  public getDisposeSamplePrintHistory(): Observable<IDisposeSamplePrintHistory[]> {
    return this.http.get<IDisposeSamplePrintHistory[]>(`${environment.baseUrl}project/getdisposesampleprinthistory`);
  }
}
